#ifdef GL_ES
precision mediump float;
#endif

uniform float u_time;
uniform float opacity;
uniform float u_darkStrength;
uniform float u_density;   
uniform float u_thinness;   
varying float vRandomValue;
varying float vAngle;
varying vec3  vColor;
#define OCTAVES     4
#define ROT_ANGLE   0.5236
#define INNER_RAD   0.2   
#define OUTER_RAD   0.8 


#pragma glslify: noise = require('../partials/noise.glsl')


float fbm2(in vec2 st, in float vRandom) {
    float v = 0.0, amp = 0.5;
    mat2 rot = mat2(cos(ROT_ANGLE), sin(ROT_ANGLE), -sin(ROT_ANGLE), cos(ROT_ANGLE));
    for(int i=0;i<OCTAVES;i++){
        v += amp * noise(st, vRandom);
        st = rot * st * 2.0 + 100.0;
        amp *= 0.5;
    }
    return v;
}

void main(){
    vec2 st = gl_PointCoord - 0.5;
    float d = length(st);
    if(d > OUTER_RAD) discard;

    float baseFade = 1.0 - smoothstep(INNER_RAD, OUTER_RAD * 0.7, d);
    float noiseFade = fbm2(st * 5.0 + u_time * 0.05, vRandomValue);
    float edge = baseFade * mix(0.5, 1.0, noiseFade);

    float c = cos(vAngle), s = sin(vAngle);
    vec2 pos = vec2(st.x * c - st.y * s, st.x * s + st.y * c);
    pos.x *= -1.5;

    float t = u_time * 0.2;
    vec2 q = vec2(fbm2(pos + t, vRandomValue), fbm2(pos - t + 1.0, vRandomValue));
    vec2 r = vec2(
        fbm2(pos + q + 0.15*t + vec2(1.7,9.2), vRandomValue),
        fbm2(pos + q + 0.126*t + vec2(8.3,2.8), vRandomValue)
    );

    float base   = fbm2(pos + r, vRandomValue);
    float sum    = 0.0;
    float amp    = 0.8;
    float freq   = 1.0;
    for(int i=0;i<OCTAVES;i++){
        float n = abs(1.0 - 2.0 * noise((pos + r) * freq, vRandomValue));
        sum    += n*n * amp;
        freq  *= 2.0;
        amp   *= 0.5;
    }
    float ridged = clamp(sum,0.0,1.0);

    float f    = mix(base, ridged, u_density);
    float nf   = pow(f, mix(3.0, 1.0, u_thinness));
    float mask = smoothstep(0.2, 1.0, nf);

    vec3 col    = vColor * 0.6;
    float lum   = dot(col, vec3(0.299,0.587,0.114));
    float dmask = pow(smoothstep(0.6,0.3,lum),1.5);
    vec3 dark   = col * (1.0 - dmask * u_darkStrength);
    vec3 light  = col * (0.5 + 0.5 * mask);
    vec3 final  = mix(light, dark * (0.5 + 0.5 * mask), dmask);

    float alpha = opacity * mask * edge;
    gl_FragColor = vec4(final, alpha);
}
